export default __webpack_public_path__ + "static/media/etranslator-screenshot-01.d9ba3e03.png";